import styled from "styled-components";
import Link from "next/link";

export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const Content = styled.main`
  flex: 1;
  padding: 6rem 2rem 3rem;
  background: white;
`;

export const ContentWrapper = styled.div`
  max-width: 900px;
  margin: 0 auto;
`;

export const Title = styled.h1`
  font-size: 3rem;
  font-weight: 800;
  color: #2c3e50;
  margin-bottom: 1.5rem;
  font-family: var(--font-poppins), sans-serif;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const Section = styled.section`
  margin-bottom: 3rem;
`;

export const SectionTitle = styled.h2`
  font-size: 1.75rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 1rem;
  font-family: var(--font-poppins), sans-serif;
`;

export const Paragraph = styled.p`
  font-size: 1.1rem;
  line-height: 1.8;
  color: #4a5568;
  margin-bottom: 1rem;
`;

export const StepContainer = styled.div`
  display: grid;
  gap: 2rem;
  margin: 2rem 0;

  @media (max-width: 768px) {
    gap: 1.5rem;
  }
`;

export const Step = styled.div`
  background: #f8f9fa;
  border-radius: 12px;
  padding: 2rem;
  border-left: 4px solid #c8553d;
`;

export const StepNumber = styled.div`
  font-size: 2.5rem;
  font-weight: 800;
  color: #c8553d;
  margin-bottom: 1rem;
`;

export const StepTitle = styled.h3`
  font-size: 1.5rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 0.75rem;
`;

export const StepDescription = styled.p`
  font-size: 1.1rem;
  line-height: 1.7;
  color: #4a5568;
`;

export const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 1.5rem 0;
`;

export const ListItem = styled.li`
  font-size: 1.1rem;
  line-height: 1.8;
  color: #4a5568;
  margin-bottom: 0.75rem;
  padding-left: 1.5rem;
  position: relative;

  &:before {
    content: "✓";
    color: #558b8d;
    font-weight: bold;
    position: absolute;
    left: 0;
  }
`;

export const CTASection = styled.div`
  background: linear-gradient(135deg, #c8553d 0%, #f2853b 100%);
  border-radius: 16px;
  padding: 3rem 2rem;
  text-align: center;
  margin-top: 3rem;
`;

export const CTATitle = styled.h3`
  font-size: 2rem;
  font-weight: 800;
  color: white;
  margin-bottom: 1rem;
`;


export const CTAButton = styled(Link)`
  display: inline-block;
  background: white;
  color: #c8553d;
  padding: 1rem 3rem;
  border-radius: 50px;
  font-weight: 700;
  font-size: 1.1rem;
  text-decoration: none;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  }
`;
